'use client';
import { useReportWebVitals } from 'next/web-vitals';
import { sendGAEvent } from '@next/third-parties/google';

// The page type a metric belongs to: the first path segment ("festivals",
// "panchanga", "rashifal"), or "home".
const pageType = () => window.location.pathname.split('/').filter(Boolean)[0] || 'home';

// Sends real-user Core Web Vitals (LCP, INP, CLS, plus FCP and TTFB) to GA4 as
// events, one per metric per page view, tagged with the page type so they can be
// reported per template. CLS is scaled by 1000 because GA4 values are integers.
const WebVitals = () => {
    useReportWebVitals((metric) => {
        sendGAEvent('event', metric.name, {
            value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
            metric_id: metric.id,
            metric_value: metric.value,
            metric_rating: metric.rating,
            page_type: pageType(),
            non_interaction: true,
        });
    });
    return null;
};

export default WebVitals;
